import { Route } from 'vue-router'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { useAuthStore } from '@/stores/auth/useAuthStore'
import { URLS } from '../routes/urlRoutes'
import { pinia } from '@/main'

export const partnerGuard = async (to: Route, _from: Route, next: any): Promise<void> => {
  const { partnerToken = '', ...rest } = to.query
  if (!partnerToken || (typeof partnerToken === 'string' && partnerToken.trim() === '')) {
    return next()
  }

  store.dispatch(`${ModuleNamespaces.SPINNER}/showSpinner`)

  const authStore = useAuthStore(pinia)
  await authStore.partnerTokenExchange(partnerToken as string)

  store.dispatch(`${ModuleNamespaces.SPINNER}/hideSpinner`)
  if (authStore.error) {
    return next({ name: URLS.LOGIN })
  } else {
    return next({
      name: to.name,
      params: to.params,
      query: { ...rest },
      replace: true
    })
  }
}
